/* eslint-disable jsx-a11y/no-autofocus */

import React, { memo } from 'react'
import styled from 'styled-components'
import { IconButton, Flex, Text } from 'pcln-design-system'
import { RadioMinus, RadioPlus } from 'pcln-icons'

const NoSelectText = styled(Text)`
  width: 30px;
  text-align: center;
  user-select: none;
`

export interface ICounter {
  autoFocus?: boolean
  className?: string
  count: number
  label: string
  min?: number
  max?: number
  onChange: (count: number) => void
}

/** @public */
const Counter = ({ autoFocus, className, count, label, min, max, onChange }: ICounter) => {
  const spacelessLabel = label && label.replace(' ', '-')

  const minusDisabled = count === min
  const plusDisabled = count === max

  const minusLabel = `Decrease ${label}${minusDisabled ? ' - disabled' : ''}`
  const plusLabel = `Increase ${label}${plusDisabled ? ' - disabled' : ''}`

  const minusColor = minusDisabled ? 'text.light' : 'primary'
  const plusColor = plusDisabled ? 'text.light' : 'primary'

  function onMinusClick() {
    return !minusDisabled && onChange(--count)
  }
  function onPlusClick() {
    return !plusDisabled && onChange(++count)
  }

  const id = `${spacelessLabel}-number`

  return (
    <Flex className={className} alignItems='center'>
      <IconButton
        autoFocus={!minusDisabled && autoFocus}
        aria-label={minusLabel}
        aria-controls={id}
        onClick={onMinusClick}
        icon={<RadioMinus title={minusLabel} color={minusColor} />}
      />
      <NoSelectText id={id} aria-live='polite' aria-atomic='true' fontSize={2} px={2}>
        {count}
      </NoSelectText>
      <IconButton
        autoFocus={minusDisabled && autoFocus}
        aria-label={plusLabel}
        aria-controls={id}
        onClick={onPlusClick}
        icon={<RadioPlus title={plusLabel} color={plusColor} />}
      />
    </Flex>
  )
}

export default memo(Counter)
